import { getAppApiRoutes } from "../../Global";
import ResponseModel from "../../models/ResponseModel";
import { apiPost } from "../apiClient";

class DeviceNeedItemService {
  async relocation(id: number): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.deviceNeedItem.relocation.replace("{id}", id.toString()), {});
  }
}

const service: DeviceNeedItemService = new DeviceNeedItemService();
export default service;
